var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h32v32H0V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 10,
    cy: 10.8,
    rx: 4,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,23c0-3.6-3.6-6.5-8-6.5S2,19.4,2,23"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 21,
    cy: 10.2,
    rx: 3.5,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28,21c0-3-3.1-5.5-7-5.5c-2.4,0-4.5,1-5.8,2.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessWhite);
export default __webpack_public_path__ + "static/media/ic_access_white.f819cf17345c83e41711701e59d2ff5b.svg";
export { ForwardRef as ReactComponent };